export const MAIN_CLASS_NAME = 'tool-info-bar';
export const COLUMN_CLASS_NAME = `${MAIN_CLASS_NAME}__column`;
export const TITLE_CELL_COLUMN_CLASS_NAME = `${COLUMN_CLASS_NAME}__title-cell`;
export const COMPONENT_CELL_COLUMN_CLASS_NAME = `${COLUMN_CLASS_NAME}__component-cell`;
